import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoaderCircleIcon } from "lucide-react";
import { cn } from "@nxt-shared/ui/lib/utils";
import { globalComponents } from "./i18n.js";
export function GlobalLoading() {
    const t = globalComponents.useT();
    return _jsx("div", { className: "h-dvh w-dvw flex items-center justify-center", children: _jsxs("div", { className: "flex flex-col items-center justify-center gap-2", children: [_jsx(LoaderCircleIcon, { className: "w-6 h-6 animate-spin" }), _jsx("div", { className: "", children: t("loading") })] }) });
}
export function LoadingInline({ className }) {
    const t = globalComponents.useT();
    return _jsxs("div", { className: cn("flex items-center justify-center gap-2 py-6 px-4", className), children: [_jsx(LoaderCircleIcon, { className: "size-6 animate-spin" }), _jsx("span", { children: t("loading") })] });
}
//# sourceMappingURL=GlobalLoading.js.map